// extracted by mini-css-extract-plugin
export var label = "_r2-0";
export var link = "_r2-1";